import module from 'fan/proyecto/module.js'
import template from './template.html'
import { orderBy } from 'lodash'

export class FanProyectoEsquemasEditarComponent {
  idProyecto
  idEsquema
  nombre
  onClose
  onChange
  data = null
  guardando = false
  $promise = null

  constructor (FanProyectoEsquemaService) {
    this.FanProyectoEsquemaService = FanProyectoEsquemaService
  }

  $onInit () {
    this.$promise = this.FanProyectoEsquemaService.get(this.idProyecto, this.idEsquema)
      .then(({data}) => {
        this.data = data
        this.data.comisionistas = orderBy(this.data.comisionistas, ['comision_porcentaje'], ['desc'])
      })
  }

  actualizar () {
    if (this.guardando) return

    this.guardando = true

    const data = {
      ...this.data,
      comisionistas: this.data.id_tipo_comision === 0 ? [] : this.data.comisionistas,
    }

    return this.FanProyectoEsquemaService.put(this.idProyecto, this.idEsquema, data)
      .then(({data}) => {
        Object.assign(this.data, data)
        this.notificar()
        this.cerrar()
      })
      .finally(() => (this.guardando = false))
  }

  notificar () {
    this.onChange({$event: {detail: this.data}})
  }

  cancelar (pristine) {
    if (!pristine) return
    this.onClose()
  }

  cerrar () {
    this.onClose()
  }
}

module.component('fanProyectoEsquemasEditar', {
  controller: FanProyectoEsquemasEditarComponent,
  template,
  bindings: {
    idProyecto: '<',
    idEsquema: '<',
    nombre: '<',
    onClose: '&',
    onChange: '&',
  },
})



// WEBPACK FOOTER //
// ./src/fan/proyecto/components/esquemas/editar/component.js